import { render, staticRenderFns } from "./Magnifier.vue?vue&type=template&id=00ba549e&"
import script from "./Magnifier.vue?vue&type=script&lang=js&"
export * from "./Magnifier.vue?vue&type=script&lang=js&"
import style0 from "./Magnifier.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports